<script setup lang="ts">
interface SectionDetailNextProps {
  currentRecordSlug: string
}

defineProps<SectionDetailNextProps>()

const { data } = await useWorks()
</script>

<template>
  <aside>
    <DetailNext
      :all-records="data.allWorks"
      :all-records-count="data._allWorksMeta.count"
      :current-record-slug="currentRecordSlug"
    />
  </aside>
</template>
